import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

import { FormFieldComponent } from '../form-field/form-field.component';
import { FormField } from '../../../interfaces';

@Component({
  selector: 'orbit-form-multiple-field',
  standalone: true,
  imports: [FormFieldComponent],
  templateUrl: './form-multiple-field.component.html',
  styleUrl: './form-multiple-field.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormMultipleFieldComponent {
  fields = input.required<FormField[]>();
}
